exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;flex-direction:column;width:100%}:host .content{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:left}:host .content .btn{color:#005092;font-style:italic}:host .highlight-item-seperator{display:flex;height:.05rem;background-color:#000;opacity:.125;margin:1rem 0}:host::ng-deep mark{background-color:#f4d73a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/faq/faq-search/faq-highlight/faq-highlight.component.scss
// module id = 688
// module chunks = 0